import React from 'react';

export default function AvatarPlaceholder({
  text = 'NA',
  className = 'text-xl',
}) {
  return (
    <div
      className={`flex items-center justify-center bg-white text-gray-700 uppercase ${className}`}
      style={{ lineHeight: '1px' }}
    >
      {text.substring(0, 2)}
    </div>
  );
}
